import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      paddingTop: theme.spacing(3.5),
      paddingBottom: theme.spacing(3.5),
      height: '100%',
      display: 'flex',
      flexDirection: 'column',

      '& > header': {
        width: '100%',
        marginBottom: theme.spacing(8),
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '1.2rem',
        '& > h1': {
          fontWeight: 500,
          marginRight: theme.spacing(8),
        },

        '& > .MuiFormControl-root': {
          flex: 1,
          minWidth: '20rem',
          margin: 0,
        },

        '& > .MuiButtonBase-root': {
          width: 'initial',
          margin: 0,
        },
      },
    },
  }),
)
